import {Emitter} from '@wonderlandengine/api';

export class NotifyPropertyChanged {
    propertyChanged: Emitter<[string]> = new Emitter();

    notifyPropertyChanged(propertyName: string) {
        this.propertyChanged.notify(propertyName);
    }
}

export function NotifyPropertyChange(
    target: any,
    propertyKey: string,
    descriptor: PropertyDescriptor
) {
    const originalSet = descriptor.set;

    descriptor.set = function (value: any) {
        if (originalSet) {
            originalSet.call(this, value);
            this.notifyPropertyChanged(propertyKey);
        }
    };
}

export function NotifyPropertyChangeField<T>(target: any, propertyKey: string) {
    let value: T;

    const getter = function () {
        return value;
    };

    const setter = function (newVal: T) {
        value = newVal;
        this.notifyPropertyChanged(propertyKey);
    };

    // Delete the original property so we can define the new ones.
    if (delete target[propertyKey]) {
        Object.defineProperty(target, propertyKey, {
            get: getter,
            set: setter,
            enumerable: true,
            configurable: true,
        });
    }
}
